module.exports = {
    baseUrl: 'http://localhost:3000',
    apiUrl: 'https://dev.carryload.eu/api/v1',  //dev server url
};
